var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Agravos"}},[_c('AgravosPropostaList',{attrs:{"subjectPermission":_vm.subjectPermission}})],1),_c('vs-tab',{attrs:{"label":"Agravos-CEP"}},[_c('AgravosCepList',{attrs:{"subjectPermission":_vm.subjectPermission}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }